import React, { memo, useCallback, useContext, useEffect } from 'react'
import { BasicDateRangePicker } from 'src/components/shared/form/BasicDateRangePicker'
import { OnboardingsContext } from '../onboardings/Onboardings.context'
import { OnboardingsTableContext } from '../onboardings-table/OnboardingsTable.context'
import { ColumnHiddenTooltip } from 'src/components/shared/ColumnHiddenTooltip'

const INVITED_AT_FIELD = 'invitedAt'

const OnboardingInvitedAtSelectComponent = () => {
  const { dateRange, setDateRange } = useContext(OnboardingsContext)
  const { columnVisibilityModel } = useContext(OnboardingsTableContext)

  const isColumnHidden = columnVisibilityModel[INVITED_AT_FIELD] === false

  const handleClear = useCallback(() => {
    setDateRange([null, null])
  }, [setDateRange])

  useEffect(() => {
    if (isColumnHidden && (dateRange[0] || dateRange[1])) {
      setDateRange([null, null])
    }
  }, [isColumnHidden, dateRange, setDateRange])

  return (
    <ColumnHiddenTooltip disabled={isColumnHidden} columnName="Invited at">
      <BasicDateRangePicker
        title="Invited at"
        value={dateRange}
        onChange={setDateRange}
        onClear={handleClear}
        disabled={isColumnHidden}
      />
    </ColumnHiddenTooltip>
  )
}

export const OnboardingInvitedAtSelect = memo(OnboardingInvitedAtSelectComponent)
